/**
 * Collection pages render the filters twice: a desktop sidebar (lg and up) and
 * the mobile Filter drawer. Only the visible copy may be submitted, so the
 * other copy's <fieldset data-filter-copy> is disabled (disabled fields are
 * left out of the form data). Re-runs when the viewport crosses lg.
 */
const desktop = window.matchMedia('(min-width: 1024px)');

function syncFilterCopies() {
  for (const copy of document.querySelectorAll('fieldset[data-filter-copy]')) {
    const isSidebar = copy.getAttribute('data-filter-copy') === 'sidebar';
    /** @type {HTMLFieldSetElement} */ (copy).disabled = isSidebar !== desktop.matches;
  }
}

syncFilterCopies();
desktop.addEventListener('change', syncFilterCopies);
